import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-danger text-white py-1.5 md:py-2.5 px-3 md:px-4 sticky top-0 z-50 shadow-lg border-b-2 border-black/30 animate-pulse-slow" data-id="element-333" data-mp="wr269r9baf2f">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-334" data-mp="3vaii6d6k7s9y">
        <div className="flex items-center gap-1.5 md:gap-2" data-id="element-335" data-mp="920t5qpjafqt">
          <span className="animate-pulse" data-id="element-336" data-mp="90fym137ywsy">⏰</span>
          <span className="font-bold uppercase tracking-[1px] hidden md:inline" data-id="element-337" data-mp="e1dgeckbhotx">
            ¡ÚLTIMAS HORAS! — LANZAMIENTO CIERRA EN:
          </span>
          <span className="font-bold uppercase tracking-[0.5px] md:hidden text-[10px]" data-id="element-338" data-mp="1kgmmw3hzt08j">
            ¡ÚLTIMAS HORAS!
          </span>
          <span className="font-display font-bold bg-black/40 px-1.5 md:px-2.5 py-0.5 md:py-1 rounded text-[13px] md:text-[18px] tracking-[1px]" data-id="element-339" data-mp="1ha289wxj1u36">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="font-bold text-[10px] md:text-base hidden sm:inline" data-id="element-340" data-mp="13bcd4mu9q4hg">
          🔥 Después sube. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-341" data-mp="tkhkn0qfi8nk">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-342" data-mp="ol52uueezrru">
        <FadeIn data-id="element-343" data-mp="kkbdrxp8k6xd">
          <div className="space-y-2 md:space-y-4" data-id="element-344" data-mp="kkl2lhyjo81h">
            <div className="inline-flex items-center gap-1.5 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full pt-[3px] pb-[3px] pl-[10px] pr-[10px]" data-id="element-345" data-mp="khymuv1i2m86">
              <span className="text-sm md:text-base" data-id="element-346" data-mp="xqanxq784by">✂️</span>
              <span className="text-[8.5px]" data-id="element-347" data-mp="10cfhplpg5qh">
                SISTEMA N°1 PARA BARBEROS EN LATINOAMÉRICA
              </span>
            </div>
            <h1 className="font-hero font-normal uppercase text-[40px] md:text-[80px] leading-[1.0] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-348" data-mp="3n69finnj6wta">
              Tu barbería llena
              <br data-id="element-349" data-mp="jp0wi0h2hqwz" />
              <span className="gold-metallic" data-id="element-350" data-mp="johj8x2d3qpa">en 48 horas.</span>
              <br data-id="element-351" data-mp="onucq0nqnw0u" />
              <span data-id="element-352" data-mp="oodkiojod415">Con publicidad.</span>
            </h1>
            <p className="text-txt-body text-[14px] md:text-[18px] leading-[1.4] md:leading-[1.7] font-sans px-3 opacity-80" data-id="element-353" data-mp="opx0ee1f5d2e">
              6 Niveles completos · Anuncios listos · Guiones de WhatsApp ·
              Sistema probado
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-354" data-mp="12m28w6cyatay">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-355" data-mp="12lsi4gk30i47">
            <div className="absolute inset-0 bg-brandOrange/15 blur-[80px] rounded-full" data-id="element-356" data-mp="17fmut019rwts"></div>
            <img src="https://cdn.magicpatterns.com/uploads/sFEQjEmUsZK8vJ3cEmMSwK/mockup_principal_sticker.png" alt="MEGAPACK BARBERO PRO — Sistema completo para barberos" loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="relative block w-full max-w-[260px] md:max-w-[520px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-357" data-mp="2s360ve2sfm6h" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-358" data-mp="2i6b3iyi93rts">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-359" data-mp="2i7cihe2e0ygs">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-360" data-mp="2e3o9qs20rwty">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-361" data-mp="3tk56cds252rk">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-362" data-mp="oqi01bnnh7nl">
                  📄
                </span>{' '}
                100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-363" data-mp="xpbxt5cpw42q">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-364" data-mp="17mq78l083slj">
                  ⚡
                </span>{' '}
                Acceso en 5 min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-365" data-mp="1gfl1kjo5k3wj">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-366" data-mp="1qeso9xgs1awb">
                  📚
                </span>{' '}
                6 Niveles
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-367" data-mp="1vazp5bubfw7e">
                <span className="text-[10px] md:text-xs text-brandOrange" data-id="element-368" data-mp="35x8j9u9vspgn">
                  🎯
                </span>{' '}
                300 páginas
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-369" data-mp="2gro1vqrwd02">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-[18px]" data-id="element-370" data-mp="2ikxtjwondca">
                💈 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-[13px] text-txt-muted font-sans" data-id="element-371" data-mp="3jxrlulvkv3bf">
                <span className="flex items-center gap-1" data-id="element-372" data-mp="l8aru4smfv35">
                  Garantía 15 días
                </span>
                <span data-id="element-373" data-mp="geg6kwxdb81y">·</span>
                <span className="flex items-center gap-1" data-id="element-374" data-mp="2anlga6356juw">Pago seguro</span>
                <span data-id="element-375" data-mp="2fn80x0lav2dq">·</span>
                <span className="flex items-center gap-1" data-id="element-376" data-mp="2fnhiq0w6y38c">Mercado Pago</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-377" data-mp="25w3mc1zjdjjf">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-378" data-mp="1rxvirb7zvjza">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-379" data-mp="1rwc2hkmc98xi">
          <FadeIn delay={0.1} data-id="element-380" data-mp="1w0jubqo3f4zy">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-381" data-mp="1hzfstbkpegrd">
              +300
            </div>
            <div className="text-sm font-sans text-txt-primary" data-id="element-382" data-mp="1mz2hch5zfjfh">
              barberos activos
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-383" data-mp="3cbntl5jphrv2">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-384" data-mp="3hd3e8whz1wcx">
              6
            </div>
            <div className="text-sm font-sans text-txt-primary" data-id="element-385" data-mp="15n3y1xhkqex7">
              Niveles listos
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-386" data-mp="1ferjnhrg91qr">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-387" data-mp="1fg2xkaelzpvl">
              6
            </div>
            <div className="text-sm font-sans text-txt-primary" data-id="element-388" data-mp="1amgmuns09w2f">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-389" data-mp="1jhefruv5l8tr">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-390" data-mp="1jg3bzv1pk12n">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-primary flex items-center justify-center gap-1" data-id="element-391" data-mp="1te9dibjlr56z">
              calificación{' '}
              <Star size={12} className="fill-brandOrange text-brandOrange" data-id="element-392" data-mp="40nucovt41s1" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MG',
    text: 'Pasé de estar perdido a tener un plan claro.',
    author: 'Matías G.',
    role: 'Barbero · Palermo',
    bg: 'bg-brandOrange',
    badge: 'Megapack'
  }, {
    initials: 'NF',
    text: 'Simple, práctico y fácil de aplicar.',
    author: 'Nico F.',
    role: 'Barbero · La Plata',
    bg: 'bg-brandOrange',
    badge: 'Megapack + Potenciadores'
  }, {
    initials: 'TC',
    text: 'No es teoría. Lo aplicás y listo.',
    author: 'Tomi C.',
    role: 'Barbero · Rosario',
    bg: 'bg-brandOrange',
    badge: 'Megapack'
  }];
  return <Section className="bg-bg-card" data-id="element-393" data-mp="34dx5u7xu3d2s">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-394" data-mp="34eyey6vahphv">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-395" data-mp="fljhrm4i8icl" data-mpi={i}>
            <div className="bg-bg-base p-3 md:p-3.5 rounded-[12px] border border-brandOrange/30 h-full flex flex-col" data-id="element-396" data-mp="jn519qbjnuvr">
              <div className="flex items-center gap-2 mb-2" data-id="element-397" data-mp="244nmi1fyzb40">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-black rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-[12px] shrink-0`} data-id="element-398" data-mp="2043oywrhi5hc">
                  {t.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-399" data-mp="1qe240dufh36n">
                  <div className="flex items-center justify-between gap-1.5" data-id="element-400" data-mp="1lfqts2080qnw">
                    <p className="font-sans font-bold text-txt-primary text-[12.5px] md:text-[13px] leading-tight truncate" data-id="element-401" data-mp="1gg4hbus7veg5">
                      {t.author}
                    </p>
                    <div className="flex text-brandOrange shrink-0" data-id="element-402" data-mp="1cgnbv1csihaz">
                      {[...Array(5)].map((_, j) => <Star key={j} size={9} className="fill-current" data-id="element-403" data-mp="36sabr2ajh7y8" data-mpi={j} />)}
                    </div>
                  </div>
                  <p className="text-[10.5px] md:text-[11px] font-sans text-txt-muted leading-tight mt-0.5" data-id="element-404" data-mp="31u0hqv0jwde7">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-primary font-quote italic text-[13px] md:text-[13.5px] leading-[1.5] mb-2.5" data-id="element-405" data-mp="dc1x0edfvjq4">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-406" data-mp="mcqdrgu7vy6p">
                <span className="inline-block bg-bg-highlight text-txt-muted font-sans font-bold uppercase tracking-[0.5px] text-[8.5px] md:text-[9px] px-1.5 py-0.5 rounded" data-id="element-407" data-mp="mdrn9gvl4cmb">
                  {t.badge}
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['El martes y el miércoles la silla está fría y no sabés cómo llenarla', 'Sentís que invertir en publicidad no es para vos.', 'Respondés WhatsApp hasta las 11 de la noche, pero sin una estrategia de marketing.', 'Subís reels, historias y estados, pero no notás un cambio en tu clientela.', 'Te cuesta subir los precios por miedo a que tus clientes se vayan.', 'Sabés que deberías cobrar más pero no tenés el sistema para justificarlo', 'Cada semana el mismo ciclo: publicar, esperar, nada, volver a publicar'];
  return <Section className="bg-bg-base" data-id="element-408" data-mp="1dix97dncmj0z">
      <div className="max-w-[720px] mx-auto" data-id="element-409" data-mp="1ij1stcjjztvf">
        <FadeIn data-id="element-410" data-mp="1ik37rs3ox0if">
          <h2 className="font-display font-extrabold uppercase md:text-[52px] text-center mb-8 text-txt-primary text-[32px]" data-id="element-411" data-mp="1ihh0ltkpon0q">
            Si sos <span className="text-brandOrange" data-id="element-412" data-mp="2abamk8nze84b">barbero</span>
            <span className="text-brandOrange" data-id="element-413" data-mp="2a8of0913bsm3">,</span>
            <br data-id="element-414" data-mp="1wagbfi9jtt1y" />
            esto te va a sonar{' '}
            <span className="text-brandOrange" data-id="element-415" data-mp="21acftim5rmi1">familiar...</span>
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-416" data-mp="21cffkud44tzy">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 md:gap-3 bg-bg-card border border-line rounded-[8px] py-1.5 px-2.5 md:py-3 md:px-4" data-id="element-417" data-mp="kyfkbwp7psj1" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={13} data-id="element-418" data-mp="5v5n2ztbs09s" />
                <p className="text-txt-primary font-sans text-[12px] md:text-[16px] leading-[1.35] md:leading-[1.5]" data-id="element-419" data-mp="1rzli5h5qx9n">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Separator */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #C9A84C 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(201,168,76,0.8), 0 0 24px rgba(201,168,76,0.5)'
        }} data-id="element-420" data-mp="3j7xzo2qvrsro"></div>

          {/* Statement block */}
          <div className="bg-bg-card p-5 md:p-8 border-l-4 border-brandOrange mb-10" data-id="element-421" data-mp="18fmqcuakbbci">
            <p className="font-sans font-bold text-[16px] md:text-[19px] text-txt-primary mb-2" data-id="element-422" data-mp="13gtmzuozp0q2">
              No es falta de <span className="text-brandOrange" data-id="element-423" data-mp="1b0m1u55ylvc9">talento</span>.
              <br data-id="element-424" data-mp="1b02n0xblvn2g" />
              No es falta de <span className="text-brandOrange" data-id="element-425" data-mp="1fz5sujzetxbh">esfuerzo</span>.
            </p>
            <p className="font-sans text-[14px] md:text-[16px] text-txt-primary opacity-80 leading-[1.6]" data-id="element-426" data-mp="1fx2rj3st4hrg">
              Es falta de un{' '}
              <span className="text-brandOrange font-bold" data-id="element-427" data-mp="1ppic88vhnkg1">sistema</span> que
              lleve clientes del anuncio a la silla.
            </p>
          </div>

          <h3 className="font-display font-extrabold uppercase md:text-[40px] text-center text-brandOrange mb-6 relative text-[28px]" data-id="element-428" data-mp="x0jomw8ljq3c">
            ¿Querés ser solo un barbero del barrio o querés crecer de verdad?
          </h3>

          <div className="space-y-4 text-txt-primary opacity-80 font-sans text-[15px] md:text-[17px] leading-[1.7] mb-10 text-center" data-id="element-429" data-mp="161hvrnec0dq5">
            <p data-id="element-430" data-mp="2de9xshekp4ju">
              Elegiste este oficio porque sos bueno con la tijera y la máquina.
            </p>
            <p data-id="element-431" data-mp="2hihlqcd7igh0">
              No para pasar horas pensando qué publicar, respondiendo mensajes y
              estresándote para que alguien reserve un turno.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border border-brandOrange/40 rounded-[14px] py-6 px-5 md:py-8 md:px-10 max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-432" data-mp="2pxyfuowf1mkj">
            <span aria-hidden="true" className="absolute -top-3 left-1/2 -translate-x-1/2 bg-bg-base px-3 font-display text-brandOrange text-[20px] leading-none" data-id="element-433" data-mp="2kx0y2dfbiujk">
              ✦
            </span>
            <p className="font-display uppercase tracking-[1px] text-[22px] md:text-[32px] leading-[1.15] text-txt-primary text-center" data-id="element-434" data-mp="38nn8ucgpisx9">
              ¿Y si este fuera el{' '}
              <span className="text-brandOrange" data-id="element-435" data-mp="33r67ggkhyi28">último mes</span> que perdés
              plata por no tener el sistema?
            </p>
          </div>
        </FadeIn>
      </div>
    </Section>;
};